module.exports = __webpack_public_path__ + "img/paw-claws.8512d7b8.svg";